import { Button, Typography, Container as UnstyledContainer } from "@mui/material";
import styled from '@mui/styled-engine';
import React from "react";
import { useTranslation } from "react-i18next";
import styles from "../../../styles";
import logo from "../../assets/logo.png";
import useTitle from "../../hooks/useTitle";
import userManager from "../../utils/userManager";

const Container = styled(UnstyledContainer)(() => ({
  height: "100vh",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  textAlign: "center",
  flexDirection: "column",
}));

const Logo = styled("img")(({ theme }: any) => ({
  maxWidth: "70%",
  maxHeight: "60%",
  paddingBottom: theme.spacing(6),
}));

const Title = styled(Typography)(({ theme }: any) => ({
  fontWeight: 600,
  paddingBottom: theme.spacing(6),
}));

const BackButton = styled(Button)(({ theme }: any) => ({
  ...styles.pinkBackground,
  padding: theme.spacing(1, 3),
  fontSize: "1rem",
  borderRadius: "2rem",
  lineHeight: "2rem",
  textDecoration: "none",
}));


const signOut = async () => {
  await userManager.signoutRedirect();
};

export const Loading = () => {
  const { t } = useTranslation();
  useTitle(t("BabyWatch"));

  return (
    <Container>
      <Logo src={logo} alt="" />

      <Title variant="h4" color="primary">
        {t("Loading")}
      </Title>
      <BackButton onClick={signOut} color="primary"> {t("Back to login")} </BackButton>

    </Container>
  );
};
